'use client';

import { useStore } from '@/providers/app-store-provider';
import { useRouter } from 'next/navigation';
import { useEffect, useRef } from 'react';

export default function HomeAuthRefreshBoundary() {
  const router = useRouter();
  const token = useStore((state) => state.token);
  const clientTokenReady = useStore((state) => state.clientTokenReady);
  const inAppH5 = useStore((state) => state.inAppH5);
  const currentLoginState = Boolean(token);
  const previousLoginStateRef = useRef<boolean | null>(null);

  useEffect(() => {
    // APP 内嵌页的登录态由 APP 通信链路处理，避免 router.refresh 打断 WebView 当前页面状态。
    if (inAppH5 || navigator.userAgent.includes('nextmar-xms-app')) return;

    // 等客户端完成 cookie token 同步后再判断，避免水合阶段误判为登录态变化导致首页无意义刷新。
    if (!clientTokenReady) return;

    // 首次只记录稳定后的登录态；服务端渲染的首页已匹配该状态，后续登录/退出变化才需要重新拉取首页模块。
    if (previousLoginStateRef.current === null) {
      previousLoginStateRef.current = currentLoginState;
      return;
    }

    if (previousLoginStateRef.current !== currentLoginState) {
      previousLoginStateRef.current = currentLoginState;
      router.refresh();
    }
  }, [clientTokenReady, currentLoginState, inAppH5, router]);

  return null;
}
